/* src/app/app.component.less */
.text-category {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
}
::ng-deep .mdc-list-item__primary-text {
  display: flex !important;
  align-items: center !important;
  column-gap: 20px;
}
mat-toolbar {
  height: 115px !important;
  justify-content: center !important;
  background:
    linear-gradient(
      90deg,
      #f53173 0%,
      #f5861d 100%);
}
::ng-deep .mat-drawer-container {
  background-color: #e7e7ef;
}
.img-container {
  display: flex;
  align-items: center;
}
.img-nav img {
  margin-top: 10px;
  margin-left: 15px;
  width: 117px;
}
@media (max-width: 650px) {
  .refresher {
    margin-top: 95px;
  }
}
@media (max-width: 360px) {
  .refresher {
    margin-top: 105px;
  }
}
::ng-deep .mat-toolbar {
  background: #ffffff;
}
.nav-bar {
  position: fixed;
  z-index: 5;
}
.safearea {
  margin-top: env(safe-area-inset-top);
}
.smooth {
  scroll-behavior: smooth;
}
.auto-icon {
  bottom: 0;
  position: relative;
}
.mat-drawer:not(.mat-drawer-side) {
  position: fixed;
}
.checkBox {
  margin-left: 30px !important;
}
.mat-toolbar-multiple-rows {
  top: 0px !important;
}
mat-icon {
  color: #ffffff;
  font-size: 28px;
  height: 30px;
  width: 30px;
}
@media screen and (max-width: 800px) {
  mat-list-item:first-of-type {
    margin-top: 10px;
  }
  mat-toolbar {
    height: 130px !important;
  }
}
::ng-deep .mat-drawer-backdrop.mat-drawer-shown {
  background-color: transparent !important;
}
.select-icon {
  color: #f53173 !important;
}
::ng-deep .mat-badge-content {
  background: #FFAEC9 !important;
  color: #ffffff !important;
}
app-switch {
  margin-left: 15px !important;
}
.layout-content {
  display: none;
}
/*# sourceMappingURL=app.component-BJFKK3LH.css.map */
